module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-17.00d518e7.JPG";